module.exports = __webpack_public_path__ + "img/trustedDevices.d0db7879.png";